import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=16f50aba&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f50aba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16f50aba', component.options)
    } else {
      api.reload('16f50aba', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=16f50aba&scoped=true&", function () {
      api.rerender('16f50aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/partners/Edit.vue"
export default component.exports